


































































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';

@Component
export default class DlgFileNew extends Vue {
  public $refs!: {
    form: any,
    file: any,
  };

  @Action('files/create') private filesCreate!: any;
  @Action('files/read') private filesRead!: any;
  @Action('files/uploadFile') private uploadFile!: any;
  @Getter('rules/all') private rules!: any;
  @Getter('files/categories') private categories!: any;

  private loading: boolean = false;
  private fileName: any = '';
  private dialog: boolean = false;
  private file: any = {};
  private selectedFile: any;
  private valid: boolean = true;

  private save() {
    if (this.$refs.form.validate()) {
      // Upload file and save path
    }
  }

  private selectFile() {
    if (this.loading) {
      return;
    }
    this.$refs.file.click();
  }

  private onFilePicked(e: any) {
    const {files} = e.target;
    if (files[0] !== undefined) {
      this.fileName = files[0].name;
      if (!this.file.title) {
        this.file.title = files[0].name;
      }

      this.selectedFile = files[0];
    }
  }

  private upload() {
    if (this.$refs.form.validate()) {
      this.loading = true;

      this.uploadFile(this.selectedFile)
        .then((url: string) => {
          this.file.url = url;
          return this.filesCreate(this.file);
        })
        .then(() => {
          return this.filesRead();
        })
        .then(() => {
          this.file = {};
          this.selectedFile = null;
          this.fileName = '';
          this.loading = false;
          this.dialog = false;
        });
    }
  }
}
